// Scroll Restoration Component - Prevents page reload on route changes
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollRestoration: React.FC = () => {
  const { pathname } = useLocation();

  // useLayoutEffect: runs before paint so child route effects (e.g. focus) don't fight scroll position.
  // behavior 'auto' is widely supported; 'instant' is not in all browsers and can leave the old scroll offset.
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.documentElement.scrollLeft = 0;
    document.body.scrollTop = 0;
    document.body.scrollLeft = 0;
  }, [pathname]);

  return null;
};




































































